import PropTypes, { element, func } from "prop-types"
import React, { useContext, useEffect, useState } from "react"
import { Link } from "react-router-dom"
import {
    Card,
    CardBody,
    Col,
    Row,
    Container,
    Badge,
    CardTitle,
    FormGroup,
    Input,
    InputGroup,
    UncontrolledTooltip,
    Button
} from "reactstrap"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import "../../assets/scss/style.css"
// import { Modal, Form, Button } from "react-bootstrap"
import { useFormik } from "formik"
import * as Yup from "yup"

import "flatpickr/dist/themes/material_blue.css"

import { withTranslation } from "react-i18next"

import { apiRoute, BASE_URL } from "routes/apiRoutes"
import axios from "axios"
import { dateformat, dateTimeformat } from "admin/commonFunction"
import Pagination, {
    bootstrap5PaginationPreset,
} from "react-responsive-pagination"
import { erroralert, toastalert } from "helpers/toast.helper"
import { capitalizeFirstLetter, makeShortNumber } from "helpers/helper"
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';

const Transaction = props => {

    document.title = "Social Links"
    const [modalShow, setModalShow] = useState(false);
    const [dateFilter, setDateFilter] = useState([])
    const [listingData, setData] = useState([])
    const [searchName, setSearchName] = useState("")
    const [statusFilter, setStatusFilter] = useState("")
    const [currentPage, setCurrentPage] = useState(1)
    const [totalCount, setTotalCount] = useState(0)
    const [loaderStatus, setLoaderStatus] = useState(true)
    const [homeActive, setHomeActive] = useState(null)
    const [editCategoryM, setEditCategoryM] = useState(null)
    let [incermentInd, setIncrementInd] = useState(1)
    const perPage = 15

    const [title, setTitle] = useState('');
    const [url, setUrl] = useState('');
    const [active, setActive] = useState('');
    const [image, setImage] = useState('');
    const [alertimage, setAlertImage] = useState(false);

    const handleShow = () => setModalShow(!modalShow);

    //fetch users
    const fetchData = async (pagenumber, pagelimit, searchName = "") => {
        try {

            let res = await axios.get(
                apiRoute.listSocial + `?page=${pagenumber}&limit=${pagelimit}&keyword=${searchName}`
            )
            if (res?.data?.status == false) {
                throw new Error(res?.data?.message)
            } else {
                console.log(res.data.data['docs']);
                setData(res.data.data['docs'])

                let pageCount = Math.ceil(res.data.data.totalDocs / perPage)
                setTotalCount(pageCount)
            }
        } catch (err) {
            // console.log(err.message, "<<--")
            erroralert(err)
        } finally {
            setLoaderStatus(false)
        }
    }


    useEffect(() => {
        fetchData(currentPage, perPage)
    }, [])

    const handlePageClick = page => {
        setCurrentPage(page)
        fetchData(page, perPage, searchName)
    }

    let [timer, setTimer] = useState(null);
    const handleSearchClick = event => {
        setSearchName(event.target.value)
        setCurrentPage(1)

        clearTimeout(timer)
        let value = setTimeout(() => {
            fetchData(1, perPage, event.target.value)
        }, 200);
        setTimer(value);
    }

    // User Update and Validation
    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            name: title ? title : editCategoryM?.name,
            url: url ? url : editCategoryM?.link,
            active: active ? active : editCategoryM?.status,
            imageFile: image,
        },
        validationSchema: Yup.object({
            name: Yup.string().required("This field is required."),
            url: Yup.string().required("This field is required."),
            active: Yup.string().required("This field is required"),
            // imageFile: Yup.required("This field is required"),
        }),
        onSubmit: async (values) => {
            if (editCategoryM && (!values.imageFile || values.imageFile.length == 0)) {
                await editCategories(values, '', editCategoryM?._id);
            } else if (!values.imageFile || values.imageFile.length == 0) {
                setAlertImage(true);
            } else {
                setAlertImage(false);
                await uploadCategoryMedia(values);
            }
        },
    })


    const uploadCategoryMedia = async (values) => {
        try {
            setLoaderStatus(true);

            let file = values.imageFile[0];
            let ext = (file.type == "image/png") ? ".png" : ".jpg"
            let avatarname = "admin_" + (new Date).getTime() + ext;
            let renamedFile = new File([file], avatarname, { type: file.type });

            const formData = new FormData();
            formData.append('file', renamedFile)
            const config = {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            }
            let res = await axios.post(apiRoute.uploadSocialMedia, {
                file: renamedFile
            }, config);
            if (res?.data?.status == false) {
                throw new Error(res?.data?.message)
            } else {
                console.log(res?.data, "<<--- file uploaded");
                if (editCategoryM) {
                    await editCategories(values, avatarname, editCategoryM?._id);
                } else {
                    await createCategory(values, avatarname);
                }
            }

        } catch (err) {
            console.log(err.message, "<<--")
            erroralert(err)
        } finally {
            setLoaderStatus(false)
        }
    }

    const createCategory = async (values, avatarname) => {
        try {

            let res = await axios.post(apiRoute.addSocial, {
                icon: avatarname,
                link: values.url,
                name: values.name,
                status: values.active,
            })
            if (res?.data?.status == false) {
                throw new Error(res?.data?.message)
            } else {
                console.log(res?.data, "<<--- file uploaded");
                toastalert('success', res?.data?.message);
                fetchData(currentPage, perPage);
            }
        } catch (err) {
            console.log(err.message, "<<--")
            erroralert(err)
        } finally {
            setLoaderStatus(false)
            handleShow();
            setTitle('');
            setActive('');
            setImage('');
        }
    }

    const editCategories = async (values, avatarname, id) => {
        try {

            let res = await axios.put(`${apiRoute.updateSocial}?social_id=${id}`, {
                icon: avatarname,
                link: values.url,
                name: values.name,
                status: values.active,
                id: id,
            })
            if (res?.data?.status == false) {
                throw new Error(res?.data?.message)
            } else {
                console.log(res?.data, "<<--- file uploaded");
                toastalert('success', res?.data?.message);
                fetchData(currentPage, perPage);
            }
        } catch (err) {
            console.log(err.message, "<<--")
            erroralert(err)
        } finally {
            setLoaderStatus(false)
            handleShow();
            setTitle('');
            setActive('');
            setImage('');
        }
    }

    const ConfirmDeleteUser = Id => {
        Swal.fire({
            title: "Are you sure?",
            text: "you want to delete this social link!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then(result => {
            if (result.isConfirmed) {
                deleteCategory(Id)
            }
        })
    }

    const deleteCategory = async (id) => {
        try {

            let res = await axios.delete(`${apiRoute.deleteSocial}?social_id=${id}`);
            if (res?.data?.status == false) {
                throw new Error(res?.data?.message)
            } else {
                toastalert('success', res?.data?.message);
                fetchData(currentPage, perPage);
            }
        } catch (err) {
            console.log(err.message, "<<--")
            erroralert(err)
        } finally {
            setLoaderStatus(false)
        }
    }

    useEffect(() => {
        console.log(editCategoryM, "editCategoryM");

    }, [editCategoryM])


    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Row>
                        <Col lg="12">
                            <Card>
                                <CardBody className="border-bottom py-2">
                                    <div className="d-flex align-items-center">
                                        <h5 className="mb-0 card-title flex-grow-1">
                                            {" "}Social Links{" "}
                                        </h5>

                                        <div className="search-box me-xxl-2 my-3 my-xxl-0 d-inline-block d-flex align-items-center gap-1">
                                            <div
                                                className="position-relative"
                                                style={{ marginTop: "10px" }}
                                            >
                                                <label htmlFor="search-bar-0" className="search-label">
                                                    <span id="search-bar-0-label" className="sr-only">
                                                        Search this table
                                                    </span>
                                                    <input
                                                        id="search-bar-0"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder={`Search Name...`}
                                                        onChange={handleSearchClick}
                                                    />
                                                </label>
                                                <i className="bx bx-search-alt search-icon"></i>
                                            </div>
                                            <Button
                                                color="success"
                                                className="btn-rounded "
                                                onClick={handleShow}
                                            >
                                                + Add New
                                            </Button>
                                        </div>
                                    </div>
                                </CardBody>
                                <CardBody>
                                    <Table
                                        id="tech-companies-1"
                                        className="table table-striped table-bordered"
                                    >
                                        <Thead>
                                            <Tr>
                                                <Th>Image</Th>
                                                <Th>Name</Th>
                                                <Th>Created on</Th>
                                                <Th>Status</Th>
                                                <Th>Action</Th>
                                            </Tr>
                                        </Thead>
                                        <Tbody>
                                            {loaderStatus ? (
                                                <Tr className="d-none">
                                                    <Td colSpan="6"> Loading ... </Td>
                                                </Tr>
                                            ) : listingData?.length != 0 ? (
                                                listingData?.map((element, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>
                                                                <img src={`${BASE_URL}/images/social/${element?.icon}`} alt="" className="rounded-circle avatar-xs" />
                                                            </td>
                                                            <td>{element?.name}</td>
                                                            <td>{dateformat(element?.create_date)}</td>
                                                            <td>{capitalizeFirstLetter(element?.status)}</td>
                                                            <td>

                                                                <div className="d-flex gap-3 align-items-center">

                                                                    <Link
                                                                        to="#"
                                                                        className="text-primary"
                                                                        onClick={() => { setEditCategoryM(element); handleShow(); }}
                                                                    >
                                                                        <i className="mdi mdi-square-edit-outline font-size-18" id="deletetooltip" />
                                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                                            Edit
                                                                        </UncontrolledTooltip>
                                                                    </Link>
                                                                    <Link
                                                                        to="#"
                                                                        className="text-primary"
                                                                        onClick={() => ConfirmDeleteUser(element?._id)}
                                                                    >
                                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                                            Delete
                                                                        </UncontrolledTooltip>
                                                                    </Link>

                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan={12} style={{ textAlign: "center" }}>
                                                        No Records Found
                                                    </td>
                                                </tr>
                                            )}
                                        </Tbody>
                                    </Table>

                                    <Row className="mt-2">
                                        <Col md={9}></Col>
                                        <Col md={3}>
                                            <Pagination
                                                {...bootstrap5PaginationPreset}
                                                current={currentPage}
                                                total={totalCount}
                                                onPageChange={page => handlePageClick(page)}
                                                className="pagination justify-content-end"
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>


            <Modal show={modalShow} onHide={handleShow} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Social Links</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form
                        onSubmit={e => {
                            e.preventDefault()
                            validation.handleSubmit()
                            return false
                        }}
                        className="validation-cls"
                    >

                        <Row>
                            <Col md={12}>
                                <div className="mb-3">
                                    <label htmlFor="floatingnameInput">Name</label>
                                    <input
                                        type="text"
                                        name="name"
                                        className="form-control"
                                        id="floatingnameInput"
                                        placeholder="Enter Name..."
                                        onBlur={validation.handleBlur}
                                        onChange={(e) => setTitle(e.target.value)}
                                        value={title ? title : editCategoryM?.name}
                                    />
                                    {validation.touched.name && validation.errors.name ? (
                                        <div className="text-danger">
                                            {validation.errors.name}
                                        </div>
                                    ) : null}
                                </div>
                            </Col>
                            <Col md={12}>
                                <div className="mb-3">
                                    <label htmlFor="floatingnameInput">URL</label>
                                    <input
                                        type="text"
                                        name="url"
                                        className="form-control"
                                        id="floatingnameInput"
                                        placeholder="Enter Name..."
                                        onBlur={validation.handleBlur}
                                        onChange={(e) => setUrl(e.target.value)}
                                        value={url ? url : editCategoryM?.link}
                                    />
                                    {validation.touched.url && validation.errors.url ? (
                                        <div className="text-danger">
                                            {validation.errors.url}
                                        </div>
                                    ) : null}
                                </div>
                            </Col>
                            {
                                editCategoryM?.icon ? <>
                                    <Col md={10}>
                                        <div className="mb-3">
                                            <label htmlFor="floatingnameInput">Image</label>
                                            <input
                                                type="file"
                                                name="image"
                                                className="form-control"
                                                id="floatingnameInput"
                                                placeholder="Enter Name..."
                                                onBlur={validation.handleBlur}
                                                onChange={(e) => setImage(e.target.files)}
                                                style={alertimage ? { border: "solid 1px red" } : {}}
                                            />
                                            {validation.touched.image && validation.errors.image ? (
                                                <div className="text-danger">
                                                    {validation.errors.image}
                                                </div>
                                            ) : null}
                                        </div>
                                    </Col>
                                    <Col md={2} className="d-flex align-items-center">
                                        <img src={`${BASE_URL}/images/social/${editCategoryM?.icon}`} alt="" className="rounded-circle avatar-xs" />
                                    </Col>
                                </> :
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label htmlFor="floatingnameInput">Image</label>
                                            <input
                                                type="file"
                                                name="image"
                                                className="form-control"
                                                id="floatingnameInput"
                                                placeholder="Enter Name..."
                                                onBlur={validation.handleBlur}
                                                onChange={(e) => setImage(e.target.files)}
                                                style={alertimage ? { border: "solid 1px red" } : {}}
                                            />
                                            {validation.touched.image && validation.errors.image ? (
                                                <div className="text-danger">
                                                    {validation.errors.image}
                                                </div>
                                            ) : null}
                                        </div>
                                    </Col>
                            }

                            <Col md={12}>
                                <div className="mb-3 d-flex gap-5 mt-2">

                                    <div className="form-check p-0 m-0">
                                        <input
                                            type="radio"
                                            className="form-check-Input me-1"
                                            id="formrow-customCheck"
                                            name="active"
                                            value="active"
                                            onClick={() => setActive("active")}
                                            defaultChecked={editCategoryM?.status == 'active' ? true : false}
                                        />
                                        <label
                                            className="form-check-Label"
                                            htmlFor="formrow-customCheck"
                                        >
                                            Active
                                        </label>
                                    </div>

                                    <div className="form-check p-0 m-0">
                                        <input
                                            type="radio"
                                            className="form-check-Input me-1"
                                            id="formrow-customCheck1"
                                            name="active"
                                            value="inactive"
                                            onClick={() => setActive("inactive")}
                                            defaultChecked={editCategoryM?.status == 'inactive' ? true : false}
                                        />
                                        <label
                                            className="form-check-Label"
                                            htmlFor="formrow-customCheck1"
                                        >
                                            Inactive
                                        </label>
                                    </div>
                                </div>

                                {validation.touched.active && validation.errors.active ? (
                                    <div className="text-danger">
                                        {validation.errors.active}
                                    </div>
                                ) : null}
                            </Col>
                        </Row>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                    }}>
                        {loaderStatus ? 'Loading...' : 'Save'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment >
    )
}


export default Transaction
